document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT_PC = 990;
  const countSlides = (root) => root.querySelectorAll('.swiper-slide').length;
  
  const getMinSlides = (type, isPc) => {
    // type: 'recommend' | 'column'
    if (type === 'products') return isPc ? 4 : 2;
    if (type === 'recommend') return isPc ? 4 : 2;
    if (type === 'column') return isPc ? 4 : 2;
    return Infinity;
  };

  const buildOptions = (type) => {
    if (type === 'products') {
      return {
        loop: true,
        loopedSlides: 6,
        speed: 600,
        spaceBetween: 30,
        slidesPerView: 1.5,
        centeredSlides: true,
        autoplay: { delay: 4000, disableOnInteraction: false },
        breakpoints: {
          990: { spaceBetween: 60, slidesPerView: 3.8, }
        }
      };
    }
    if (type === 'recommend') {
      return {
        loop: true,
        loopedSlides: 6,
        speed: 600,
        spaceBetween: 30,
        slidesPerView: 1.5,
        centeredSlides: true,
        autoplay: { delay: 4000, disableOnInteraction: false },
        breakpoints: {
          990: { spaceBetween: 60, slidesPerView: 3.8, }
        }
      };
    }
    // column
    return {
      loop: true,
      loopedSlides: 6,
      speed: 600,
      spaceBetween: 30,
      slidesPerView: 1.5,
      centeredSlides: true,
      autoplay: { delay: 4000, disableOnInteraction: false },
      breakpoints: {
        990: { spaceBetween: 60, slidesPerView: 3.5 }
      }
    };
  };

  const initOne = (el, type) => {
    const isPc = window.matchMedia(`(min-width: ${BREAKPOINT_PC}px)`).matches;
    const minSlides = getMinSlides(type, isPc);
    const slidesCount = countSlides(el);
    const hasSwiper = !!el.swiper;

    if (slidesCount < minSlides) {
      if (hasSwiper) {
        el.swiper.destroy(true, true);
      }
      el.classList.remove('is-swiper-enabled');
      el.classList.add('c-slider--static');
      return;
    }

    el.classList.remove('c-slider--static');

    if (!hasSwiper) {
      const paginationEl = el.querySelector('.swiper-pagination');
      const nextEl = el.querySelector('.c-slider__arrows-next');
      const prevEl = el.querySelector('.c-slider__arrows-prev');

      new Swiper(el, {
        ...buildOptions(type),
        pagination: paginationEl ? { el: paginationEl, type: 'progressbar' } : undefined,
        navigation: (nextEl && prevEl) ? { nextEl, prevEl } : undefined,
      });

      el.classList.add('is-swiper-enabled');
    }
  };

  const initAll = () => {
    document.querySelectorAll('.js-products-slider').forEach((el) => initOne(el, 'products'));
    document.querySelectorAll('.js-recommend-slider').forEach((el) => initOne(el, 'recommend'));
    document.querySelectorAll('.js-column-slider').forEach((el) => initOne(el, 'column'));
  };

  initAll();

  let timer = null;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(initAll, 200);
  });
});


//コラムマウスオーバー
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-column-slider').forEach((slider) => {
    const wrapper = slider.querySelector('.c-slider__list.swiper-wrapper');
    const badge = slider.querySelector('.js-slider-pointer');
    if (!wrapper || !badge) return;

    // カーソルに被らないオフセット
    const offsetX = 20;
    const offsetY = -20;

    // 追従の“ゆっくり度”（0〜1。小さいほどゆっくり）
    const ease = 0.12;

    // target: マウス座標 / current: 表示座標
    let tx = -9999, ty = -9999;
    let cx = -9999, cy = -9999;

    let rafId = null;

    const render = () => {
      rafId = null;

      // イージングでゆっくり追従
      cx += (tx - cx) * ease;
      cy += (ty - cy) * ease;

      badge.style.transform = `translate3d(${cx}px, ${cy}px, 0) scale(1)`;

      // mouseleave時の縮小用に保持
      badge.style.setProperty('--badge-x', `${cx}px`);
      badge.style.setProperty('--badge-y', `${cy}px`);

      // まだ差があるなら次フレームも描画
      if (Math.abs(tx - cx) > 0.2 || Math.abs(ty - cy) > 0.2) {
        rafId = requestAnimationFrame(render);
      }
    };

    const requestRender = () => {
      if (rafId == null) rafId = requestAnimationFrame(render);
    };

    const show = () => {
      badge.classList.remove('is-hide');
      badge.classList.add('is-show');
    };

    const hide = () => {
      badge.classList.remove('is-show');
      badge.classList.add('is-hide');
    };

    // ★イベントは wrapper のみに付ける（ここがポイント）
    wrapper.addEventListener('mouseenter', () => {
      show();
    });

    wrapper.addEventListener('mousemove', (e) => {
      const rect = slider.getBoundingClientRect();
      tx = e.clientX - rect.left + offsetX;
      ty = e.clientY - rect.top + offsetY;
      requestRender();
    });

    wrapper.addEventListener('mouseleave', () => {
      hide();
    });

    // 初期状態：隠す
    hide();
  });
});